module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Patient-Zero.fd15363.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Patient-Zero.jpg
// module id = 49+O
// module chunks = 0